/**
 * @desc 保存
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.MskuMapSaveRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
